import { httpClient } from "../http-client";
import { NEW_API_ENDPOINTS } from "../../../shared/constants/api";
import type { ProductionRecord, GetProductionRecordsRequest } from "../../../domain/types/production-record";
import type { PageResponse } from "../../../shared/types/common";

export interface ApiResponseProductionRecords {
  data: PageResponse<ProductionRecord>;
  errorMsg: string | null;
  errorCode: string | null;
}

export class CompanyProductionRecordApiService {
  /**
   * 회사의 생산 실적 목록을 조회합니다.
   */
  async getProductionRecords(request: GetProductionRecordsRequest): Promise<ApiResponseProductionRecords> {
    const params = new URLSearchParams();

    if (request.routerId !== undefined) {
      params.append("routerId", request.routerId.toString());
    }
    if (request.machineId !== undefined) {
      params.append("machineId", request.machineId.toString());
    }
    if (request.startDate) {
      params.append("startDate", request.startDate);
    }
    if (request.endDate) {
      params.append("endDate", request.endDate);
    }
    if (request.hasOrder !== undefined) {
      params.append("hasOrder", request.hasOrder.toString());
    }
    if (request.page !== undefined) {
      params.append("page", request.page.toString());
    }
    if (request.size !== undefined) {
      params.append("size", request.size.toString());
    }

    const queryString = params.toString();
    const url = `${NEW_API_ENDPOINTS.companyProductionRecordController.GET(request.companyId)}${queryString ? `?${queryString}` : ""}`;

    const response = await httpClient.get<ApiResponseProductionRecords>(url);

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "생산 실적을 가져오지 못했습니다.");
    }

    return response.data;
  }
}

export const companyProductionRecordApiService = new CompanyProductionRecordApiService();
